import { IApplicationState } from '../../types/redux';

export function getDisclaimerText(state: IApplicationState) {
  return state.newbuilding.disclaimerText;
}
